import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import {
  Identifiable,
  Project,
  Zone,
  zoneProjectsRetrievalFilter,
} from "@planzone/dto";

function reduceProjects(
  chunks: (Identifiable<Project> & {
    zone: Identifiable<Zone>;
  })[][],
): (Identifiable<Project> & {
  zone: Identifiable<Zone>;
})[] {
  return chunks.reduce((list, projects) => [...list, ...projects], []);
}

function createInteractor(repository: Repository): Interactor {
  return (planzone) =>
    present(
      repository
        .getZones(planzone)
        .then((zones) =>
          zones.map((zone) =>
            repository
              .getZoneProjects(zone, {
                ...zoneProjectsRetrievalFilter,
                limit: 999999,
              })
              .then((projects) =>
                projects.map((project) => ({ ...project, zone })),
              ),
          ),
        )
        .then((promises) => Promise.all(promises))
        .then(reduceProjects)
        .then((projects) => ({ planzone, projects }))
        .catch((error) => Promise.reject(planzone)),
    );
}

export { createInteractor };
export type { Interactor };
